export default class Analytics {
    constructor(delay=250) {
        /* Delay for action register */
        this.delay = delay
        /* Timeout variable for delayed execution */
        this.timeout = null
        /* Payload variable for analytics data */
        this.payload = null
        /* Previous payload variable to prevent repeated sends */
        this.prevPayload = null
    }

    enter(detailLevel, stateName='') {
        /* Set payload */
        this.payload = {
            type: "coronaGraphDetail",
            detailLevel: detailLevel,
            stateName: stateName,
        }
        /* Set timeout */
        this.setTimeout()
    }

    exit() {
        /* Clear timeout */
        this.clearTimeout()
        /* Clear payload */
        this.payload = null
        this.prevPayload = null
    }

    move(detailLevel, stateName='') {
        /* Clear timeout */
        this.clearTimeout()
        /* Set payload */
        this.payload = {
            type: "coronaGraphDetail",
            detailLevel: detailLevel,
            stateName: stateName,
        }
        /* Set timeout */
        this.setTimeout()
    }

    sendMessage() {
        /* Check if payload changed */
        if (JSON.stringify(this.payload) !== JSON.stringify(this.prevPayload)) {
            /* Send message if new payload exists */
            window.parent.postMessage(this.payload, "*")
            /* Update previous payload */
            this.prevPayload = this.payload
        }
        /* Clear timeout */
        this.clearTimeout()
    }
    
    setTimeout() {
        /* Set function execution after delay */
        this.timeout = setTimeout(
            this.sendMessage.bind(this),
            this.delay
        )
    }

    clearTimeout() {
        /* Clear scheduled function execution */
        clearTimeout(this.timeout)
        this.timeout = null
    }
}
